import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAction, vuexfireMutations } from 'vuexfire'
import { isProduction } from '@/utilities/helpers'
import accounts from '@/store/accounts'
import battle from '@/store/battle'
import battles from '@/store/battles'
import bestiary from '@/store/bestiary'
import combatant from '@/store/combatant'
import effect from '@/store/effect'
import favourites from '@/store/favourites'
import settings from '@/store/settings'
import fb from '@/utilities/firebase-config'
export const db = fb.database() // alias here so firebase-mock works

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: !isProduction(),

  modules: {
    accounts,
    battle,
    battles,
    bestiary,
    combatant,
    effect,
    favourites,
    settings,
  },

  getters: {
    battle(state, getters, rootState, rootGetters) {
      return rootGetters[`battles/battle`]
    },
  },

  actions: {
    // ref is optional
    // used for writes so security rules apply
    updateDb: firebaseAction(({ commit }, { ref, ...updates }) => {
      return commit(`doUpdates`, { updates, ref })
    }),
  },

  mutations: {
    ...vuexfireMutations,
    doUpdates(state, { ref = db.ref(), updates }) {
      ref.update(updates, error => (error ? console.log(error) : true))
    },
  },
})

export default store
export { battle, battles, bestiary, combatant, effect, favourites }
